import React from "react";
import {
    //TODO: UNCOMMENT WHEN STATIC PAGES ARE READY
    //DocumentChartBarIcon,
    //DocumentDuplicateIcon,
    //EyeIcon,
    HomeIcon,
    Squares2X2Icon,
    DocumentTextIcon
} from "@heroicons/react/24/outline";
import { DetailProvider } from "@pages/ProjectDetail/components/projectProvider/ProjectDetailContext";


const withProvider = (Component, Provider) => {
    return (props) => (
        <Provider>
            <Component {...props} />
        </Provider>
    );
};

const Home = React.lazy(() =>
    import(/* webpackChunkName: "home" */ "@pages/Home")
);
// TODO: UNCOMMENT WHEN STATIC PAGES ARE READY
// const MapExamples = React.lazy(() =>
//     import(/* webpackChunkName: "map-examples" */ "@pages/MapExamples")
// );
// const ChartExamples = React.lazy(() =>
//     import(/* webpackChunkName: "chart-examples" */ "@pages/ChartExamples")
// );
// const TableExamples = React.lazy(() =>
//     import(/* webpackChunkName: "table-examples" */ "@pages/TableExamples")
// );

const Dashboards = React.lazy(() =>
    import(/* webpackChunkName: "projects" */ "@pages/Dashboards")
);

const ProjectDetail = React.lazy(() =>
    import(/* webpackChunkName: "projects" */ "@pages/ProjectDetail/ProjectDetail")
);

const TemplateDetail = React.lazy(() =>
    import(/* webpackChunkName: "projects" */ "@pages/ProjectDetail/TemplateDetail")
);

const routes = [
    {
        name: "Home",
        href: "/home",
        Icon: HomeIcon,
        component: Home,
        hidden: false,
    },
    // TODO: Uncomment the following routes when the other public pages are ready
    // {
    //     name: "Ai_act",
    //     href: "/charts",
    //     Icon: DocumentDuplicateIcon,
    //     component: ChartExamples,
    //     hidden: false,
    // },
    // {
    //     name: "About",
    //     href: "/tables",
    //     Icon: EyeIcon,
    //     component: TableExamples,
    //     hidden: false,
    // },
    // {
    //     name: "Impact_tool",
    //     href: "/maps",
    //     Icon: DocumentChartBarIcon,
    //     component: MapExamples,
    //     hidden: false,
    // },
    {
        name: "Projects",
        href: "/projects",
        // scopes: ["audit:read"],
        Icon: Squares2X2Icon,
        component: Dashboards,
        hidden: false,
    },
    {
        name: "templates",
        scopes: ["audit:update"],
        href: "/template",
        Icon: DocumentTextIcon,
        component: Dashboards,
        hidden: false,
    },
    {
        name: "TemplateDetails",
        href: "/template/:templateId",
        component: withProvider(TemplateDetail, DetailProvider),

        hidden: true,
    },
    {
        name: "ProjectDetails",
        href: "/projects/:projectId",
        component: withProvider(ProjectDetail, DetailProvider),
        hidden: true,
    },
];

export default routes;